import React, {useEffect, useState} from "react";
import axios from "axios";
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import {requestAPI} from "../services";
import {toast} from "react-toastify";
import thLocale from "@fullcalendar/core/locales/th";
import {CgSandClock} from "react-icons/cg";
import {BsCheckAll} from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import {Col, Row} from "react-bootstrap";

const Calendar = () => {
    const [events,setEvents] = useState([]);
    // จะเรียกใช้เมื่อหน้าเว็บพร้อมใช้งาน
    useEffect(() => {
        // การดึง data
        axios.get("https://ltic.kku.ac.th/booking/strapi/bookings?_limit=-1").then((res) => {
            console.log('===', res.data);
            let data = res.data.map(booking=>{
                return {
                    title:`(${booking.startTime.replace(':00.000','')}-${booking.endTime.replace(':00.000','')}) 
                    ${booking.booking_room.name} / ${booking.booking_user.firstname} ${booking.booking_user.lastname}`,

                    date:booking.startDate,
                    infoEvent:booking.nameActivity,
                    infoUser:`${booking.booking_user.firstname} ${booking.booking_user.lastname}`,
                    roomName:booking.booking_room.name,
                    backgroundColor: booking.booking_status.name == 'Approve'? '#57c128' : '#efe22c',
                    borderColor:booking.booking_status.name == 'Approve'? '#57c128' : '#efe22c',
                    textColor:'#000000'
                }
            })
            setEvents(data);
        })
    }, []);
    return (
        <div>
            <Row className="mt-4 mb-3">
                <Col>
                    <h3>ห้องทั้งหมด</h3>
                </Col>
                <Col>
                    <Row>
                        <Col><div style={{background:'#EFE22C',borderRadius:5,padding:3,textAlign:'center',whiteSpace:'nowrap'}}><CgSandClock/> Pending</div></Col>
                        <Col><div style={{background:'#57C128',borderRadius:5,padding:3,textAlign:'center',whiteSpace:'nowrap'}}><BsCheckAll/> Approved</div></Col>
                    </Row>
                </Col>
            </Row>
            <FullCalendar
                plugins={[dayGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                hiddenDays={[0, 6]}
                weekends={false}

                headerToolbar={{
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,dayGridWeek,dayGridDay',
                }}

                events={events}
                locale={thLocale}
                eventContent={(arg) => {
                    let strTip = `${arg.event.extendedProps.roomName}<br/>กิจกรรม : ${arg.event.extendedProps.infoEvent}<br/>ผู้จอง : ${arg.event.extendedProps.infoUser}`;
                    if (arg.event.extendedProps.otherUser) {
                        strTip = `กิจกรรม : ${arg.event.extendedProps.infoEvent}`;
                    }
                    return <div>
                        <p style={{margin: 0, whiteSpace: 'normal'}} data-tip={strTip}>

                            {arg.event.extendedProps.otherUser ?
                                <div className='p-1'>{arg.event.title}</div>
                                :
                                <div className='p-1' style={{cursor: 'pointer'}}>{arg.event.extendedProps.statusID == 3 ?
                                    <CgSandClock/> : <BsCheckAll/>} {arg.event.title}</div>
                            }
                        </p>
                        <ReactTooltip multiline={true}/>
                    </div>
                }}
            />
        </div>
    )
}
export default Calendar